module.exports = __webpack_public_path__ + "img/banner-xtools.fdf3d9e9.png";